import React from 'react';
import { Box, Typography } from "@mui/material";

const Details = () => {
  return (
    <Box m="20px">
      <Typography variant="h2" color="primary">
        Farmer Seed Page
      </Typography>
      <Typography variant="body1">
        Here is the content for the Farmer Details page.
      </Typography>
    </Box>
  );
};

export default Details;